<template>
    <h2 class="text-3xl xl:text-4xl font-bold ml-4">
        <slot></slot>
    </h2>
</template>
